import { GitstreamTheme } from '@linearb/linui-common';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './RTK';
import { DashboardLayout } from './layouts/DashboardLayout/DashboardLayout';
import { PageNotFound } from './views/404/PageNotFound';
import LoginPage from './views/login';
import Dashboard from './views/root/views/dashboard/Dashboard';
import Playground from './views/root/views/playground';
import { PageAnalytics } from './components/PageAnalytics';

// Set up react-query
const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <BrowserRouter>
          <GitstreamTheme>
            <Routes>
              <Route path='/login' element={<LoginPage />} />
              <Route path='/playground' element={<Playground />} />
              <Route path='/' element={<DashboardLayout />}>
                <Route path='/' element={<Dashboard />} />
                <Route path='/*' element={<PageNotFound />} />
              </Route>
            </Routes>
            <PageAnalytics />
          </GitstreamTheme>
        </BrowserRouter>
      </Provider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
